/* global axios */

import ApiClient from './ApiClient';

// Build multipart FormData con campos canned_response[*] + attachments[].
// Usado por create/update cuando el caller incluye `attachments: File[]`.
// attachmentsToKeep: array de IDs de attachments existentes a preservar en update.
const buildFormData = ({
  short_code: shortCode,
  content,
  attachments = [],
  attachmentsToKeep = [],
}) => {
  const form = new FormData();
  if (shortCode !== undefined)
    form.append('canned_response[short_code]', shortCode);
  if (content !== undefined) form.append('canned_response[content]', content);
  attachments.forEach(file => form.append('attachments[]', file));
  attachmentsToKeep.forEach(id => form.append('keep_attachment_ids[]', id));
  return form;
};

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(payload) {
    if (payload?.attachments?.length) {
      return axios.post(this.url, buildFormData(payload));
    }
    return axios.post(this.url, payload);
  }

  update(id, payload) {
    if (payload?.attachments?.length || payload?.attachmentsToKeep) {
      return axios.patch(`${this.url}/${id}`, buildFormData(payload));
    }
    return axios.patch(`${this.url}/${id}`, payload);
  }
}

export default new CannedResponse();
